<template>
  <div>
    <div class="col-md-12 mt-4 text-center">
      <hr class="custom-hr mb-4" />
    </div>

    <form @submit.prevent="formUserUpdate">
      <div class="row">
        <div class="form-group bordered">
          <label for="name" class="form-label text-left">Nombre y Apellido</label>
          <input type="text" class="form-control" id="name" v-model="name" />
        </div>
        <div class="form-group bordered">
          <label for="username" class="form-label text-left">Usuario - para iniciar sesión</label>
          <input type="text" class="form-control" id="username" v-model="username" />
        </div>
        <div class="form-group bordered">
          <label for="email" class="form-label text-left">Email</label>
          <input type="email" class="form-control" id="email" v-model="email" />
        </div>
        <div class="form-group bordered">
          <label for="currentPassword" class="form-label text-left">Contraseña Actual</label>
          <input type="password" class="form-control" id="currentPassword" v-model="currentPassword" autocomplete/>
        </div>
        <div class="form-group bordered">
          <label for="password" class="form-label text-left">Contraseña</label>
          <input type="password" class="form-control" id="password" v-model="password" autocomplete/>
        </div>
        <div class="form-group bordered">
          <label for="confirmPassword" class="form-label text-left">Confirmar Contraseña</label>
          <input type="password" class="form-control" id="confirmPassword" v-model="confirmPassword" autocomplete/>
        </div>
        <div class="form-group bordered col-md-4 mt-3">
          <label for="roles" class="form-label text-left">Roles</label>
          <select v-model="selectedRole" class="form-control">
            <option value="" disabled>-- Selecciona Rol --</option>
            <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.roleName }}</option>
          </select>
        </div>
      </div>
      
      <hr class="custom-hr" />

      <div class="row mb-3">
        <div class="col-md-12">
          <div class="form-group d-grid gap-2">
            <button
              type="submit"
              title="Guardar Cambios"
              class="btn btn-block btn-custom"
            >
              Modificar
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
  import { ref, onMounted } from 'vue'
  import apiUsers from '../../../apis/User'
  import { handleError, handleSweetInfo } from '../../../Utils/StatusHandler'
  import { showSpinner, closeSpinner } from '../../../Utils/AlertHandler'


  export default {
    name: 'FormEdit',
    props: {
      data: Object,
      dataSelection: Object,
    },

    setup(props) {
      const loading = ref(true);
      const mostrarForm = ref(false);
      const errors = ref([]);
      const alert = ref([]);
      const id = ref('');
      const name = ref('');
      const username = ref('');
      const email = ref('');
      const createdAt = ref('');
      const currentPassword = ref('');
      const password = ref('');
      const confirmPassword = ref('');
      const roles = ref(props.dataSelection);
      const selectedRole = ref('');

      const handleErrors = (error) => {
        handleError(error, { errors });
      };
      
      const handleSweetAlert = (info) => {
        handleSweetInfo(info, { alert });
      };
            
      const cargarDatos = async () => {
        const userData = props.data;

        id.value = userData.id;
        name.value = userData.name;
        username.value = userData.username;
        email.value = userData.email;
        selectedRole.value = userData.roles[0].id;
      };

      const formUserUpdate = async () => {
        const idUsuario = id.value;

        try {
          showSpinner();
          const datosEditados = {
            id: idUsuario,
            name: name.value,
            username: username.value,
            email: email.value,
            currentPassword: currentPassword.value,
            password: password.value,
            confirmPassword: confirmPassword.value,
            rol: selectedRole.value,
          };

          const response = await apiUsers.putUpdateUser(datosEditados)
          
          if (response) {
            closeSpinner();
            handleSweetAlert(response);
          }
        } catch (error) {
          console.error(error)
          closeSpinner();
          handleSweetAlert(error);
        }
      };

      onMounted(() => {
        cargarDatos();
      });

      return {
        loading,
        mostrarForm,
        errors,
        alert,
        id,
        name,
        username,
        email,
        createdAt,
        currentPassword,
        password,
        confirmPassword,
        roles,
        selectedRole,
        formUserUpdate,
      };
    },
    created() {
      this.id = this.$route.params.id;
    },
  };
</script>
